import { useParams } from "react-router-dom";
import StockControlProvider from "../../../hooks/stockControls/StockControlProvider";

import useUser from "../../../hooks/user/useUser";
import StockControlView from "./main";

const StockControlEditionView = () => {
    const user = useUser();
    const { stockControlId } = useParams();
    
    return (
        <StockControlProvider>
            <StockControlView warehouseId={user.branch.warehouseId} stockControlId={stockControlId} branchCode={user.branch.code} />
        </StockControlProvider>
    )
}

export default StockControlEditionView;